<footer class="shadow-panel relative z-10 flex items-center bg-neutral-0 px-20 py-4">
  <div class="flex flex-1 items-center gap-4">
    <img
      priority="true"
      alt="Product logo"
      width="43"
      height="32"
      [ngSrc]="'/assets/images/logo.svg'"
    />
    <span>Система адміністрування</span>
  </div>
  <p>{{ "Всі права захищені. " + currentYear }}</p>
</footer>
